import { channelConstants, sortFormMonths } from "./dashboard.constants";
export function formattedDate(inputDate) {
    var date = new Date(inputDate);
    // Extract date components
    var year = date.getUTCFullYear();
    var month = String(date.getUTCMonth() + 1).padStart(2, "0");
    var day = String(date.getUTCDate()).padStart(2, "0");
    var hours = String(date.getUTCHours()).padStart(2, "0");
    var minutes = String(date.getUTCMinutes()).padStart(2, "0");
    var seconds = String(date.getUTCSeconds()).padStart(2, "0");
    // Formatted date string
    var formattedDate = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    return formattedDate;
}
export var getTimeZoneInHours = function () {
    var timezoneOffset = new Date().getTimezoneOffset();
    var offset = Math.abs(timezoneOffset);
    //%2B - '+', because these are sent in query params in API URL
    var offsetOperator = timezoneOffset < 0 ? "%2B" : "-";
    var offsetHours = Math.floor(offset / 60)
        .toString()
        .padStart(2, "0");
    var offsetMinutes = Math.floor(offset % 60)
        .toString()
        .padStart(2, "0");
    return "".concat(offsetOperator).concat(offsetHours, ":").concat(offsetMinutes);
};
export var isWAChannel = function (ch) { return ch === channelConstants.WHATSAPP; };
export var isSmsChannel = function (ch) { return ch === channelConstants.SMS; };
export var isEmailChannel = function (ch) { return ch === channelConstants.EMAIL; };
export var isAllChannel = function (ch) { return ch === channelConstants.ALL_CHANNEL; };
export var isVoiceChannel = function (ch) { return ch === channelConstants.VOICE; };
export var isRCSChannel = function (ch) { return ch === channelConstants.RCS; };
export var isVRChannel = function (ch) { return ch === channelConstants.VIRTUAL_RECEPTIONIST; };
export var isNetworkChannel = function (ch) { return ch === channelConstants.NETWORK; };
/**
 * Filters the list of month names to include only those within the start and end dates,
 * handling year-end wrapping (e.g., Oct -> Feb).
 *
 * @param {string} startDate - The start date string (e.g., "2025-10-10T...").
 * @param {string} endDate - The end date string (e.g., "2026-02-10T...").
 * @returns {string[]} An array of month names within the inclusive range.
 */
export function getMonthsBySelectedDates(startDate, endDate) {
    // Date.getMonth() returns 0 for Jan, 11 for Dec. This matches the array index (i).
    var startMonthIndex = new Date(startDate).getMonth();
    var endMonthIndex = new Date(endDate).getMonth();
    if (startMonthIndex <= endMonthIndex) {
        // Case 1: Range is within the same year (e.g., April to September)
        return sortFormMonths.filter(function (_, i) { return i >= startMonthIndex && i <= endMonthIndex; });
    }
    else {
        // Case 2: Range wraps around the year end (e.g., October to February)
        // This includes all months from the start month up to December (i >= startMonthIndex)
        // AND all months from January up to the end month (i <= endMonthIndex)
        return sortFormMonths.filter(function (_, i) { return i >= startMonthIndex || i <= endMonthIndex; });
    }
}
